<template>
    <el-dialog :title="$t('editClassify')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog">
        <div class="content">
            <el-form :model="formData"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="110px">
                <el-form-item :label="$t('classifyName')"
                              prop="name">
                    <el-input v-model="formData.name"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('classifyCategory')" prop="type">
                    <el-select v-model="formData.type" :placeholder="$t('pleaseSelectHint')">
                        <el-option
                            v-for="item in typeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('sortValue')" prop="sort">
                    <el-input type="Number" v-model="formData.sort"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Icon" prop="icon" key="icon" v-if="formData.type === 101">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequest"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.icon" class="avatar" v-if="formData.icon">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveImage" v-if="formData.icon"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="Icon" v-else>
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequest"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.icon" class="avatar" v-if="formData.icon">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveImage" v-if="formData.icon"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"
                       size="mini"
                       :disabled="disabled"
                       @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {queryAdvertClassifyDetails, updateAdvertClassify, uploadImage} from "@/api/modules/api";

export default {
    name: 'Add',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            dialogVisible: false,
            typeOptions: [
                {
                    label: this.$t('condition'),
                    value: 101
                },
                {
                    label: this.$t('special'),
                    value: 102
                },
                {
                    label: this.$t('recommend'),
                    value: 103
                }
            ],
            formData: {
                name: '',
                type: '',
                sort: 0,
                icon: ''
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                type: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                sort: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                icon: [{ required: true, message: this.$t('uploadImageHint'), trigger: 'change' }],
            },
            disabled: false,
        }
    },
    created () { },
    mounted () { },
    components: {},
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            // 获取详情
            this.getDetails()
        },
    
        // 获取详情
        getDetails () {
            queryAdvertClassifyDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    this.formData = {
                        name: resData.name,
                        type: resData.type,
                        sort: resData.sort || 0,
                        icon: resData.icon
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
        
        /******** 图片 ********/
        httpRequest(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.icon = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err);
                })
        },
        // 清除图片
        handleRemoveImage () {
            this.formData.icon = ''
        },
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            const params = {
                id: this.parentId,
                name: this.formData.name.trim(),
                type: this.formData.type,
                sort: this.formData.sort,
                icon: this.formData.icon
            }
            this.disabled = true;
            updateAdvertClassify(params).then((res) => {
                this.disabled = false;
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.disabled = false;
                this.$message.error(err);
            });
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/form-dialog.scss';
</style>
